export default {
  HOST: "http://localhost:4000/",
  WEBSOCKET_HOST: "ws://localhost:4000/",
  DISCORD_CLIENT_ID: "686324632013242398",
  DISCORD_PERMISSIONS: "268437552",
};
